import { GQL } from "@binale-tech/shared";
import Tag from "../../../../scripts/models/Tag";

export const getTagDisplayName = (document: Pick<GQL.IDocument, "documentDate" | "tag">, tags: Map<string, Tag[]>) => {
    const { tag, documentDate } = document;
    if (!tag) {
        return null;
    }
    const year = documentDate ? documentDate.split(".").pop() : undefined;
    if (!year) {
        return tag;
    }
    if (!tags) {
        return tag;
    }
    const yearTags = tags.get(year);
    if (!yearTags.length) {
        return tag;
    }
    const tagDatabase = yearTags.find(v => v.key === tag);
    if (!tagDatabase) {
        return tag;
    }
    return `${tagDatabase.num} - ${tagDatabase.name}`;
};
